// window 相关生命周期埋点

const { Trace, TRACE_DATA_TYPE_ENUM } = require(".");
import { v4 } from "uuid";
window.__webuuid = v4();

window.document.addEventListener("DOMContentLoaded", function () {
  Trace({ lifeDes: "DOMContentLoaded" }, TRACE_DATA_TYPE_ENUM.windowLife);
});

window.addEventListener("load", function (ev) {
  Trace({ lifeDes: "load" }, TRACE_DATA_TYPE_ENUM.windowLife);
});

window.addEventListener("error", function (ev) {
  Trace(
    { lifeDes: "error", message: String(ev.message) },
    TRACE_DATA_TYPE_ENUM.windowLife
  );
});

window.addEventListener("unload", function () {
  // navigator.sendBeacon("/analytics", JSON.stringify(analyticsData));
  // 无法检测, 暂时不添加
});

window.addEventListener("online", function (ev) {
  // console.log("online-ev: ", ev);
  Trace(
    { lifeDes: "online", type: ev.type, desc: "已连接网络!" },
    TRACE_DATA_TYPE_ENUM.windowLife
  );
});

// window.addEventListener("offline", function (ev) {
//   // console.log("offline-ev: ", ev);
//   Trace(
//     { lifeDes: "offline", type: ev.type, desc: "已断开网络!" },
//     TRACE_DATA_TYPE_ENUM.windowLife
//   );
// });

/** 页面可见性改变 visible hidden */
window.document.addEventListener("visibilitychange", () => {
  Trace(
    { lifeDes: "visibilitychange", visibilityState: document.visibilityState },
    TRACE_DATA_TYPE_ENUM.windowLife
  );
});
